import { Batch } from '../models/Batch';
import { exciseDutyInfoNL } from '../data/exciseInfo';

export function calculateEstimatedExciseDutyEUR(batches: Batch[]): number {
  const total = batches.reduce((sum, batch) => {
    const liters = batch.yield ?? 0;
    const abv = batch.abvFinal ?? 0;

    const isSession = abv <= exciseDutyInfoNL.session.abvLimit;
    const ratePer100L = isSession ? exciseDutyInfoNL.session.ratePer100L : exciseDutyInfoNL.still.ratePer100L;

    const ratePerLiter = ratePer100L / 100;
    const dutyEUR = liters * ratePerLiter;

    return sum + dutyEUR;
  }, 0);

  return total;
}
